import { useQuery,useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { ExtractFnReturnType, MutationConfig } from '@/lib/react-query';

import { Service, ServiceResponse } from '../types';

export type UseServiceOptions = {
  businessId?: number;
  page?: number;
  perPage?: number;
  parent?: string;
  addons?: boolean;
  active?: boolean;
  headers?: {
    'loc-id'?: string;
  };
};
export const getServices = ({ businessId, page, perPage, parent, headers , addons, active}: UseServiceOptions = {}): Promise<ServiceResponse> => {
  return axios.get(`/service/${businessId}/all`, {
    params: { page, perPage, parent, addons, active},
    headers: {
      'loc-id': headers?.['loc-id'],
    },
  });
};


type UseOptions = {
  config?: MutationConfig<typeof getServices>;
};

export const useGetService= ({ config }: UseOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: getServices,
  });
};
